// Auto-generated from lib/i18n.js (mechanical split — do not hand-reorder).
// Namespace "saas" base dictionary. New keys for feature batches go in sibling
// fragment files, merged in ./index.js — not here.
export default {
  "fr": {
      "nav.practitionerLogin": "Connexion praticien",
      "nav.teamLogin": "Équipe Solunary",
      "nav.openMenu": "Ouvrir le menu",
      "nav.closeMenu": "Fermer le menu",
      "nav.blog": "Blog",
      "nav.login": "Connexion",
      "nav.startTrial": "Démarrer l'essai",
      "nav.features": "Fonctionnalités",
      "nav.marketplace": "Marketplace",
      "nav.pricing": "Tarifs",
      "nav.about": "À propos",
      "nav.contact": "Contact",
      "nav.support": "Support",
      "hero.tagline": "Conçu pour celles et ceux qui soignent et enseignent",
      "hero.titleA": "Conçu pour ceux",
      "hero.titleB": "qui soignent et enseignent",
      "hero.subtitle": "Le système d'exploitation propulsé par l'IA où santé alternative et éducation ne font qu'un. Soignez vos clients. Enseignez à vos communautés. Bâtissez une économie du soin — au même endroit.",
      "hero.ctaPrimary": "Démarrer l'essai gratuit",
      "hero.ctaSecondary": "Voir comment ça marche",
      "dualpillar.eyebrow": "Deux piliers. Une économie du soin.",
      "dualpillar.title": "Soigner et enseigner, réunis",
      "dualpillar.body": "Chaque praticien moderne mène deux activités : une pratique clinique en 1:1 et une activité éducative en 1:plusieurs — cours, cohortes, adhésions. Aujourd'hui, cela revient à assembler quatre outils qui ne se parlent pas. Solunary est la première plateforme conçue pour les deux. Une même fiche client circule de la réservation → séance 1:1 → inscription au cours → suivi. Une marque. Un parcours. Une économie du soin.",
      "dualpillar.treat": "☀ Soigner",
      "dualpillar.treatModules": "Practice · Flow · Care",
      "dualpillar.teach": "☾ Enseigner",
      "dualpillar.teachModules": "Learn · Pathways",
      "dualpillar.intelligence": "✦ Solunary AI · Insights",
      "dualpillar.journeyLabel": "Une fiche client, un parcours",
      "dualpillar.j1": "Réservation",
      "dualpillar.j2": "Séance 1:1",
      "dualpillar.j3": "Inscription au cours",
      "dualpillar.j4": "Communauté",
      "dualpillar.j5": "Suivi",
      "pricing.bothPillars": "Chaque forfait inclut les deux piliers — Practice (soigner) et Academy (enseigner). Même client. Même parcours. Un seul Solunary.",
      "pricing.tier.seed": "Soignez vos premiers clients en toute confiance.",
      "pricing.tier.flow": "Soignez en 1:1 et enseignez en 1:plusieurs — votre activité de soin complète.",
      "pricing.tier.ascend": "Faites grandir votre clinique et votre académie ensemble.",
      "pricing.tier.orbit": "Pilotez une organisation de soin multi-praticiens à l'échelle entreprise.",
      "hero.trustedBy": "Approuvé par 2 000+ praticiens dans le monde",
      "ecosystem.eyebrow": "L'écosystème",
      "ecosystem.titleA": "Deux piliers. Neuf modules.",
      "ecosystem.titleB": "À composer selon vous.",
      "ecosystem.title": "Un écosystème complet",
      "ecosystem.subtitle": "Tous les outils dont vous avez besoin pour faire grandir votre pratique.",
      "ecosystem.practice": "Gestion de cabinet",
      "ecosystem.journeys": "Parcours patients",
      "ecosystem.ai": "Assistant IA",
      "ecosystem.telehealth": "Télésanté",
      "ecosystem.automations": "Automatisations",
      "ecosystem.payments": "Paiements & facturation",
      "ecosystem.insights": "Analytique & insights",
      "ecosystem.courses": "Cours & éducation",
      "ecosystem.community": "Communauté & adhésions",
      "pricing.title": "Tarification transparente",
      "pricing.subtitle": "Choisissez le plan adapté à votre pratique. Chaque plan inclut un essai gratuit — une carte est requise à l'inscription, et rien n'est débité avant la fin de l'essai.",
      "pricing.monthly": "Mensuel",
      "pricing.annual": "Annuel",
      "pricing.annualWithSave": "Annuel · jusqu'à {percent}% d'économie",
      "pricing.billedAnnually": "Facturé {total} par an · {saved} économisés",
      "pricing.extraPractitioner": "+ {price}/mois par praticien supplémentaire",
      "pricing.eyebrow": "Formules d'abonnement",
      "pricing.headingA": "Choisissez votre formule,",
      "pricing.headingB": "un seul parcours",
      "pricing.pickCycle": "Au mois ou à l'année, comme vous préférez.",
      "pricing.pickCycleSave": "Au mois, ou jusqu'à {percent}% d'économie avec la facturation annuelle.",
      "pricing.choosePlan": "Choisir {plan}",
      "pricing.contactSales": "Parler à l'équipe commerciale",
      "pricing.funnel.eyebrow": "Le parcours par défaut",
      "pricing.funnel.combo": "« {plan} + {install} + {porting} » =",
      "pricing.funnel.amount": "{monthly}/mois + {oneTime} une seule fois",
      "pricing.funnel.promise": "→ tout est installé, tout est repris, en ligne en une semaine.",
      "pricing.perMonth": "/mois",
      "pricing.perYear": "/an",
      "pricing.selectPlan": "Choisir ce plan",
      "pricing.comingSoon": "Bientôt disponible",
      "pricing.eta": "· {eta}",
      "pricing.unlimited": "Illimité",
      "footer.tagline": "Conçu pour celles et ceux qui soignent et enseignent.",
      "footer.rights": "Tous droits réservés.",
      "finalCta.title": "Soyez en ligne en une semaine.",
      "finalCta.subtitle": "Soignez et enseignez depuis une seule plateforme. Essai gratuit de {days} jours — une carte est requise, rien n'est débité avant la fin de l'essai.",
      "finalCta.cta": "Démarrer l'essai gratuit",
      "footer.copyright": "© {year} Solunary · Conçu pour celles et ceux qui soignent et enseignent",
      "footer.product": "Produit",
      "footer.legal": "Légal",
      "footer.company": "Entreprise",
      "footer.terms": "Conditions d'utilisation",
      "footer.privacy": "Politique de confidentialité",
      "footer.features": "Fonctionnalités",
      "footer.pricing": "Tarifs",
      "footer.marketplace": "Marketplace",
      "footer.support": "Support & Contact",
      "footer.contact": "Contact",
      "terms.pageTitle": "Conditions Générales d'Utilisation",
      "terms.pageSubtitle": "Tout ce que vous devez savoir sur vos droits, vos obligations et l'utilisation de la plateforme Solunary.",
      "terms.tableOfContents": "Table des matières",
      "terms.searchPlaceholder": "Rechercher une clause, un mot-clé (remboursement, IA, dossiers...)",
      "terms.noResults": "Aucune clause ne correspond à votre recherche.",
      "terms.clearSearch": "Effacer la recherche",
      "terms.print": "Imprimer / PDF",
      "terms.copied": "Lien copié !",
      "terms.copyLink": "Copier le lien de la section",
      "terms.lastUpdated": "Dernière mise à jour",
      "terms.effectiveDate": "Date d'effet",
      "terms.version": "Version",
      "terms.summaryTitle": "Points clés en un coup d'œil",
      "terms.summary1Title": "Commerçant officiel",
      "terms.summary1Desc": "Solunary encaisse les paiements clients et tient le registre financier via Stripe.",
      "terms.summary2Title": "Dossiers de bien-être",
      "terms.summary2Desc": "Solunary n'est pas un DME certifié. Le praticien demeure seul responsable de sa conformité clinique.",
      "terms.summary3Title": "Supervision IA humaine",
      "terms.summary3Desc": "Les sorties IA sont des brouillons nécessitant impérativement la validation préalable du praticien.",
      "terms.summary4Title": "Propriété de vos données",
      "terms.summary4Desc": "Vous conservez 100 % de la propriété intellectuelle sur votre patientèle, vos cours et vos contenus.",
      "terms.practiceTermsTitle": "Conditions de réservation spécifiques du cabinet",
      "terms.practiceTermsBadge": "Cabinet",
      "terms.contactTitle": "Une question sur nos conditions ?",
      "terms.contactDesc": "Notre équipe juridique et conformité est à votre disposition pour vous guider.",
      "terms.contactButton": "Contacter l'équipe juridique",
      "terms.allClauses": "Toutes les clauses",
      "terms.showingCount": "{count} sections trouvées",
      "support.badge": "Support & Contact",
      "support.pageTitle": "Comment pouvons-nous vous aider ?",
      "support.pageSubtitle": "Que vous découvriez Solunary, gériez votre cabinet ou ayez des questions juridiques, notre équipe est là pour vous.",
      "support.directEmailTitle": "Email direct",
      "support.directEmailSub": "Joindre toute l'équipe",
      "support.emailHelpNote": "Tous les messages envoyés à cette adresse sont traités par notre équipe avec suivi des réponses.",
      "support.helpfulResources": "Ressources utiles",
      "support.formHeading": "Ouvrir un ticket d'assistance",
      "support.formHelp": "Notre équipe répond généralement sous 24 à 48 heures ouvrées. Une confirmation vous sera adressée par email.",
      "support.formTitle": "Comment pouvons-nous vous aider ?",
      "support.formSubtitle": "Soumettez votre demande ci-dessous ou écrivez-nous directement à",
      "support.nameLabel": "Votre nom",
      "support.emailLabel": "Votre adresse email",
      "support.categoryLabel": "Catégorie de la demande",
      "support.subjectLabel": "Objet",
      "support.messageLabel": "Message",
      "support.subjectPlaceholder": "Résumé succinct de votre question",
      "support.messagePlaceholder": "Précisez votre demande avec tous les détails utiles...",
      "support.send": "Envoyer le message",
      "support.submitting": "Envoi en cours…",
      "support.successTitle": "Demande bien reçue !",
      "support.successMessage": "Merci d'avoir contacté Solunary. Votre demande a été transmise à notre équipe et un accusé de réception a été envoyé à votre adresse email.",
      "support.ticketReference": "Référence du ticket",
      "support.anotherInquiry": "Envoyer une autre demande",
      "support.catGeneral": "Renseignements généraux",
      "support.catBilling": "Facturation & Abonnements",
      "support.catTechnical": "Assistance technique & Plateforme",
      "support.catLegal": "Juridique, Données & Conformité",
      "support.catFeedback": "Retours & Suggestions",
      "support.catPartnership": "Partenariats & Presse",
      "support.errorName": "Veuillez renseigner votre nom.",
      "support.errorEmail": "Veuillez renseigner une adresse email valide.",
      "support.errorSubject": "Veuillez préciser l'objet de votre demande.",
      "support.errorMessage": "Veuillez rédiger un message d'au moins 5 caractères.",
      "support.errorGeneric": "Échec de l'envoi du ticket. Veuillez écrire directement à hey@solunary.health.",
      "support.close": "Fermer",
      "support.done": "Terminé",
      "signup.title": "Créer votre compte Solunary",
      "signup.subtitle": "Essai gratuit de {days} jours — une carte est requise à l'inscription, mais rien n'est débité avant la fin de l'essai.",
      "signup.practiceName": "Nom de la pratique",
      "signup.slug": "Votre adresse web",
      "signup.slugHint": "Choisissez votre sous-domaine. Vous pourrez connecter votre propre domaine personnalisé plus tard.",
      "signup.slugChecking": "Vérification…",
      "signup.slugAvailable": "Adresse disponible",
      "signup.currency": "Devise",
      "signup.plan": "Plan",
      "signup.submit": "Commencer mon essai",
      "signup.submitting": "Création en cours…",
      "signup.demoModeActive": "Mode démo actif",
      "signup.demoModeBody": "Aucun paiement réel ne sera prélevé. Le compte sera activé immédiatement à des fins de test.",
      "signup.googleConnected": "Connecté avec Google :",
      "signup.emailHintGoogle": "Adresse de votre compte Google — elle servira à vous connecter.",
      "signup.emailHintManual": "Utilisez l'adresse du compte Google avec lequel vous vous connecterez ensuite.",
      "signup.or": "ou",
      "signup.ownerNamePlaceholder": "Dre Marie Dupont",
      "signup.practiceNamePlaceholder": "Cabinet de naturopathie Lune",
      "signup.practiceNameOptionalHint": "Facultatif — sinon, nous utilisons votre adresse courriel. Modifiable ensuite dans les réglages.",
      "signup.billingLabel": "Facturation",
      "signup.billingMonthly": "Mensuel",
      "signup.billingAnnual": "Annuel · 2 mois offerts",
      "signup.acceptTermsPrefix": "J'accepte les",
      "signup.acceptTermsMiddle": "et la",
      "faq.title": "Questions fréquentes",
      "faq.q1": "Combien de temps pour mettre mon cabinet en ligne ?",
      "faq.a1": "Avec le pack Turnkey Install, vous êtes opérationnel en une semaine. Sans Turnkey, comptez 24h pour la mise en route + quelques jours pour personnaliser.",
      "faq.q2": "Puis-je migrer mes données existantes ?",
      "faq.a2": "Oui. {express} ({expressPrice}) automatise la reprise depuis Practice Better, Jane, SimplePractice, Healthie et Acuity. {assisted} ({assistedPrice}) gère les cas complexes.",
      "faq.a2Generic": "Oui. La reprise automatisée couvre Practice Better, Jane, SimplePractice, Healthie et Acuity, et une formule accompagnée gère les cas complexes — voir les forfaits de reprise de données ci-dessus.",
      "faq.q3": "Et si j'ai une équipe multi-praticiens ?",
      "faq.a3": "Le plan {plan} inclut {included} praticiens, puis {extra}/mois par praticien supplémentaire. Les organisations enterprise disposent d'un plan sur mesure (praticiens illimités, SSO, etc.).",
      "faq.a3Generic": "Oui. Les plans multi-praticiens incluent une équipe de praticiens, puis facturent un montant mensuel par praticien supplémentaire ; la grille tarifaire ci-dessus indique les chiffres en vigueur. Les organisations enterprise disposent d'un plan sur mesure (praticiens illimités, SSO, etc.).",
      "faq.q4": "Comment fonctionne Solunary Pay ?",
      "faq.a4": "Les paiements de vos clients sont traités via Stripe et facturés par Solunary à {rate}. Plus simple qu'une intégration Stripe directe, et activé en un clic.",
      "faq.a4Generic": "Les paiements de vos clients sont traités via Stripe et facturés par Solunary. Plus simple qu'une intégration Stripe directe, et activé en un clic ; le tarif en vigueur figure dans les frais de plateforme ci-dessus.",
      "faq.q5": "Et si je veux annuler ?",
      "faq.a5": "Aucun engagement sur le mensuel. Annulation en un clic depuis votre tableau de bord. La facturation annuelle permet jusqu'à {percent}% d'économie.",
      "faq.a5Generic": "Aucun engagement sur le mensuel. Annulation en un clic depuis votre tableau de bord. La facturation annuelle coûte moins cher que le paiement mois par mois.",
      "feature.practice.text": "Réservations, calendrier, factures, cartes-cadeaux, produits — votre cœur opérationnel.",
      "feature.journeys.text": "Protocoles multi-étapes, formulaires d'intake, plans de traitement, cadences de suivi.",
      "feature.ai.text": "Propulsé par Claude Sonnet 4.5. Chatbot patient + assistant admin + insights quotidiens.",
      "feature.telehealth.text": "Appels vidéo HD, notes de séance, signatures électroniques, enregistrements — entièrement intégrés.",
      "feature.automations.text": "Moteur Déclencheur → Action. 7 déclencheurs, 5 actions, éditeur visuel sans code.",
      "feature.payments.text": "Solunary Pay. Abonnements, paiements uniques, cartes-cadeaux. Multi-devises.",
      "feature.insights.text": "Briefings IA quotidiens + tableaux de bord KPI + rapports de rétention par cohorte.",
      "feature.courses.text": "Vendez des cours, programmes, adhésions. Contenu progressif, certificats.",
      "feature.community.text": "Cercles privés, communautés payantes, forums liés à vos plans de traitement."
  },
  "en": {
      "nav.practitionerLogin": "Practitioner Login",
      "nav.teamLogin": "Solunary Team",
      "nav.openMenu": "Open menu",
      "nav.closeMenu": "Close menu",
      "nav.blog": "Blog",
      "nav.login": "Log in",
      "nav.startTrial": "Start Free Trial",
      "nav.features": "Features",
      "nav.marketplace": "Marketplace",
      "nav.pricing": "Pricing",
      "nav.about": "About",
      "nav.contact": "Contact",
      "nav.support": "Support",
      "hero.tagline": "Built for Those Who Heal and Teach",
      "hero.titleA": "Built for Those",
      "hero.titleB": "Who Heal and Teach",
      "hero.subtitle": "The AI operating system where alternative health and education work as one. Treat clients. Teach communities. Build a healing economy — all in one place.",
      "hero.ctaPrimary": "Start Free Trial",
      "hero.ctaSecondary": "See how it works",
      "dualpillar.eyebrow": "Two pillars. One healing economy.",
      "dualpillar.title": "Treat and teach, working as one",
      "dualpillar.body": "Every modern healer runs two businesses: a 1:1 clinical practice and a 1:many education business — courses, cohorts, memberships. Today, that means stitching four tools that don't talk to each other. Solunary is the first platform built for both. One client record flows from booking → 1:1 session → course enrollment → follow-up. One brand. One journey. One healing economy.",
      "dualpillar.treat": "☀ Treat",
      "dualpillar.treatModules": "Practice · Flow · Care",
      "dualpillar.teach": "☾ Teach",
      "dualpillar.teachModules": "Learn · Pathways",
      "dualpillar.intelligence": "✦ Solunary AI · Insights",
      "dualpillar.journeyLabel": "One client record, one journey",
      "dualpillar.j1": "Booking",
      "dualpillar.j2": "1:1 session",
      "dualpillar.j3": "Course enrollment",
      "dualpillar.j4": "Community",
      "dualpillar.j5": "Follow-up",
      "pricing.bothPillars": "Every plan includes both pillars — Practice (treat) and Academy (teach). Same client. Same journey. One Solunary.",
      "pricing.tier.seed": "Treat your first clients with confidence.",
      "pricing.tier.flow": "Treat 1:1 and teach 1:many — your full healing business.",
      "pricing.tier.ascend": "Scale your clinic and your academy together.",
      "pricing.tier.orbit": "Run a multi-practitioner healing organization at enterprise scale.",
      "hero.trustedBy": "Trusted by 2,000+ practitioners worldwide",
      "ecosystem.eyebrow": "The Ecosystem",
      "ecosystem.titleA": "Two pillars. Nine modules.",
      "ecosystem.titleB": "Yours to compose.",
      "ecosystem.title": "A complete ecosystem",
      "ecosystem.subtitle": "Every tool you need to grow your practice.",
      "ecosystem.practice": "Practice Management",
      "ecosystem.journeys": "Client Journeys",
      "ecosystem.ai": "AI Assistant",
      "ecosystem.telehealth": "Telehealth",
      "ecosystem.automations": "Automations",
      "ecosystem.payments": "Payments & Billing",
      "ecosystem.insights": "Insights & Analytics",
      "ecosystem.courses": "Courses & Education",
      "ecosystem.community": "Community & Memberships",
      "pricing.title": "Transparent pricing",
      "pricing.subtitle": "Pick the plan that fits your practice. Every plan includes a free trial — a card is required at signup, and nothing is charged until the trial ends.",
      "pricing.monthly": "Monthly",
      "pricing.annual": "Annual",
      "pricing.annualWithSave": "Annual · save up to {percent}%",
      "pricing.billedAnnually": "Billed {total} annually · {saved} saved",
      "pricing.extraPractitioner": "+ {price}/mo per extra practitioner",
      "pricing.eyebrow": "Subscription tiers",
      "pricing.headingA": "Pick your plan,",
      "pricing.headingB": "one journey",
      "pricing.pickCycle": "Pick monthly or annual billing, whichever suits you.",
      "pricing.pickCycleSave": "Pick monthly, or save up to {percent}% with annual billing.",
      "pricing.choosePlan": "Choose {plan}",
      "pricing.contactSales": "Contact sales",
      "pricing.funnel.eyebrow": "The default funnel",
      "pricing.funnel.combo": "\"{plan} + {install} + {porting}\" =",
      "pricing.funnel.amount": "{monthly}/mo + {oneTime} one-time",
      "pricing.funnel.promise": "→ fully set up, fully migrated, live in a week.",
      "pricing.perMonth": "/mo",
      "pricing.perYear": "/yr",
      "pricing.selectPlan": "Select this plan",
      "pricing.comingSoon": "Coming soon",
      "pricing.eta": "· {eta}",
      "pricing.unlimited": "Unlimited",
      "footer.tagline": "Built for those who heal and teach.",
      "footer.rights": "All rights reserved.",
      "finalCta.title": "Be live in a week.",
      "finalCta.subtitle": "Treat and teach from one platform. A {days}-day free trial — a card is required, nothing is charged until it ends.",
      "finalCta.cta": "Start Free Trial",
      "footer.copyright": "© {year} Solunary · Built for those who heal and teach",
      "footer.product": "Product",
      "footer.legal": "Legal",
      "footer.company": "Company",
      "footer.terms": "Terms of Service",
      "footer.privacy": "Privacy Policy",
      "footer.features": "Features",
      "footer.pricing": "Pricing",
      "footer.marketplace": "Marketplace",
      "footer.support": "Contact & Support",
      "footer.contact": "Contact",
      "terms.pageTitle": "Terms and Conditions",
      "terms.pageSubtitle": "Everything you need to know about your rights, responsibilities, and use of the Solunary platform.",
      "terms.tableOfContents": "Table of Contents",
      "terms.searchPlaceholder": "Search terms, clauses, topics (refund, AI, records...)",
      "terms.noResults": "No clauses match your search query.",
      "terms.clearSearch": "Clear search",
      "terms.print": "Print / PDF",
      "terms.copied": "Link copied!",
      "terms.copyLink": "Copy section link",
      "terms.lastUpdated": "Last updated",
      "terms.effectiveDate": "Effective date",
      "terms.version": "Version",
      "terms.summaryTitle": "Key Highlights at a Glance",
      "terms.summary1Title": "Merchant of Record",
      "terms.summary1Desc": "Solunary collects client payments and maintains double-entry ledger settlement via Stripe.",
      "terms.summary2Title": "Wellness Records",
      "terms.summary2Desc": "Solunary is not a certified EMR. Practitioners retain clinical and regulatory responsibility.",
      "terms.summary3Title": "Human-in-the-Loop AI",
      "terms.summary3Desc": "All AI outputs are assistive drafts requiring practitioner review before client delivery.",
      "terms.summary4Title": "Your Data, Your Content",
      "terms.summary4Desc": "You retain 100% intellectual property ownership of your clients, courses, and practice data.",
      "terms.practiceTermsTitle": "Practice-Specific Booking Terms",
      "terms.practiceTermsBadge": "Practice",
      "terms.contactTitle": "Questions regarding our Terms?",
      "terms.contactDesc": "Our legal and compliance team is available to assist practitioners and clients.",
      "terms.contactButton": "Contact Legal Team",
      "terms.allClauses": "All clauses",
      "terms.showingCount": "{count} sections found",
      "support.badge": "Support & Contact",
      "support.pageTitle": "How can we assist you?",
      "support.pageSubtitle": "Whether you are exploring Solunary, managing your practice, or have legal questions, our team is here to help.",
      "support.directEmailTitle": "Direct Email",
      "support.directEmailSub": "Reach the entire team",
      "support.emailHelpNote": "All inquiries sent to this address are routed to our support and technical leads with reply tracking.",
      "support.helpfulResources": "Helpful Resources",
      "support.formHeading": "Submit a Support Ticket",
      "support.formHelp": "Our team typically answers within 24 business hours. A copy will be emailed to your inbox.",
      "support.formTitle": "How can we help you?",
      "support.formSubtitle": "Submit your ticket below or email us directly at",
      "support.nameLabel": "Your Name",
      "support.emailLabel": "Your Email",
      "support.categoryLabel": "Inquiry Category",
      "support.subjectLabel": "Subject",
      "support.messageLabel": "Message",
      "support.subjectPlaceholder": "Brief summary of your question",
      "support.messagePlaceholder": "Provide any details so our team can assist you efficiently...",
      "support.send": "Send Message",
      "support.submitting": "Sending...",
      "support.successTitle": "Inquiry Received!",
      "support.successMessage": "Thank you for contacting Solunary. We have dispatched your inquiry to our support team and sent a confirmation receipt to your email.",
      "support.ticketReference": "Ticket Reference",
      "support.anotherInquiry": "Send another inquiry",
      "support.catGeneral": "General Inquiry",
      "support.catBilling": "Billing & Subscriptions",
      "support.catTechnical": "Technical & Platform Help",
      "support.catLegal": "Legal, Privacy & Compliance",
      "support.catFeedback": "Feedback & Feature Requests",
      "support.catPartnership": "Partnership & Press",
      "support.errorName": "Please enter your name.",
      "support.errorEmail": "Please enter a valid email address.",
      "support.errorSubject": "Please enter a subject for your inquiry.",
      "support.errorMessage": "Please describe your request in at least 5 characters.",
      "support.errorGeneric": "Failed to submit support ticket. Please write to hey@solunary.health directly.",
      "support.close": "Close",
      "support.done": "Done",
      "signup.title": "Create your Solunary account",
      "signup.subtitle": "A {days}-day free trial — a card is required at signup, but nothing is charged until the trial ends.",
      "signup.practiceName": "Practice name",
      "signup.slug": "Your web address",
      "signup.slugHint": "Choose your subdomain. You can connect your own custom domain later.",
      "signup.slugChecking": "Checking…",
      "signup.slugAvailable": "Address available",
      "signup.currency": "Currency",
      "signup.plan": "Plan",
      "signup.submit": "Start my trial",
      "signup.submitting": "Creating…",
      "signup.demoModeActive": "Demo mode active",
      "signup.demoModeBody": "No real payment will be charged. The account will be activated immediately for testing purposes.",
      "signup.googleConnected": "Connected with Google:",
      "signup.emailHintGoogle": "Your Google account address — it will be used to sign you in.",
      "signup.emailHintManual": "Use the address of the Google account you'll sign in with afterward.",
      "signup.or": "or",
      "signup.ownerNamePlaceholder": "Dr. Marie Dupont",
      "signup.practiceNamePlaceholder": "Lune Naturopathy Clinic",
      "signup.practiceNameOptionalHint": "Optional — we'll use your email address instead. You can change it later in Settings.",
      "signup.billingLabel": "Billing",
      "signup.billingMonthly": "Monthly",
      "signup.billingAnnual": "Annual · 2 months free",
      "signup.acceptTermsPrefix": "I accept the",
      "signup.acceptTermsMiddle": "and the",
      "faq.title": "Frequently asked questions",
      "faq.q1": "How long to get my practice online?",
      "faq.a1": "With the Turnkey Install pack, you're up and running in one week. Without Turnkey, expect 24h to get started + a few days to customize.",
      "faq.q2": "Can I migrate my existing data?",
      "faq.a2": "Yes. {express} ({expressPrice}) automates the move from Practice Better, Jane, SimplePractice, Healthie and Acuity. {assisted} ({assistedPrice}) handles complex cases.",
      "faq.a2Generic": "Yes. Automated migration covers Practice Better, Jane, SimplePractice, Healthie and Acuity, and an assisted option handles complex cases — see the data-migration packages above.",
      "faq.q3": "What if I have a multi-practitioner team?",
      "faq.a3": "The {plan} plan includes {included} practitioners, then {extra}/mo per extra practitioner. Enterprise organizations get a custom plan (unlimited practitioners, SSO, etc.).",
      "faq.a3Generic": "Yes. The multi-practitioner plans include a team of practitioners and then charge a monthly rate per extra practitioner; the pricing table above shows the current figures. Enterprise organizations get a custom plan (unlimited practitioners, SSO, etc.).",
      "faq.q4": "How does Solunary Pay work?",
      "faq.a4": "Your clients' payments are processed through Stripe and billed by Solunary at {rate}. Simpler than a direct Stripe integration, and enabled in one click.",
      "faq.a4Generic": "Your clients' payments are processed through Stripe and billed by Solunary. Simpler than a direct Stripe integration, and enabled in one click; the rate in force is listed under the platform fees above.",
      "faq.q5": "What if I want to cancel?",
      "faq.a5": "No commitment on monthly. Cancel in one click from your dashboard. Annual billing saves you up to {percent}%.",
      "faq.a5Generic": "No commitment on monthly. Cancel in one click from your dashboard. Annual billing costs less than paying month by month.",
      "feature.practice.text": "Bookings, calendar, invoices, gift cards, products — your operational core.",
      "feature.journeys.text": "Multi-step protocols, intake forms, treatment plans, follow-up cadences.",
      "feature.ai.text": "Claude Sonnet 4.5 powered. Patient chatbot + admin assistant + daily insights.",
      "feature.telehealth.text": "HD video calls, session notes, e-signatures, recordings — fully integrated.",
      "feature.automations.text": "Trigger → Action engine. 7 triggers, 5 actions, no-code visual builder.",
      "feature.payments.text": "Solunary Pay. Subscriptions, one-time, gift cards. Multi-currency.",
      "feature.insights.text": "Daily AI briefings + KPI dashboards + cohort retention reports.",
      "feature.courses.text": "Sell courses, programs, memberships. Drip-content, certificates.",
      "feature.community.text": "Private circles, paid communities, forums tied to your treatment plans."
  },
  "es": {
      "nav.practitionerLogin": "Acceso de profesional",
      "nav.teamLogin": "Equipo Solunary",
      "nav.openMenu": "Abrir menú",
      "nav.closeMenu": "Cerrar menú",
      "nav.blog": "Blog",
      "nav.login": "Iniciar sesión",
      "nav.startTrial": "Probar gratis",
      "nav.features": "Funciones",
      "nav.marketplace": "Marketplace",
      "nav.pricing": "Precios",
      "nav.about": "Acerca",
      "nav.contact": "Contacto",
      "nav.support": "Soporte",
      "hero.tagline": "Hecho para quienes sanan y enseñan",
      "hero.titleA": "Hecho para quienes",
      "hero.titleB": "sanan y enseñan",
      "hero.subtitle": "El sistema operativo con IA donde la salud alternativa y la educación funcionan como una sola. Atiende a tus clientes. Enseña a tus comunidades. Construye una economía del cuidado — todo en un solo lugar.",
      "hero.ctaPrimary": "Probar gratis",
      "hero.ctaSecondary": "Ver cómo funciona",
      "dualpillar.eyebrow": "Dos pilares. Una economía del cuidado.",
      "dualpillar.title": "Sanar y enseñar, como uno solo",
      "dualpillar.body": "Cada sanador moderno gestiona dos negocios: una práctica clínica 1:1 y un negocio educativo 1:muchos — cursos, cohortes, membresías. Hoy eso significa unir cuatro herramientas que no se comunican entre sí. Solunary es la primera plataforma creada para ambos. Una misma ficha de cliente fluye desde la reserva → sesión 1:1 → inscripción al curso → seguimiento. Una marca. Un viaje. Una economía del cuidado.",
      "dualpillar.treat": "☀ Atender",
      "dualpillar.treatModules": "Practice · Flow · Care",
      "dualpillar.teach": "☾ Enseñar",
      "dualpillar.teachModules": "Learn · Pathways",
      "dualpillar.intelligence": "✦ Solunary AI · Insights",
      "dualpillar.journeyLabel": "Una ficha de cliente, un viaje",
      "dualpillar.j1": "Reserva",
      "dualpillar.j2": "Sesión 1:1",
      "dualpillar.j3": "Inscripción al curso",
      "dualpillar.j4": "Comunidad",
      "dualpillar.j5": "Seguimiento",
      "pricing.bothPillars": "Cada plan incluye ambos pilares — Practice (atender) y Academy (enseñar). Mismo cliente. Mismo viaje. Un solo Solunary.",
      "pricing.tier.seed": "Atiende a tus primeros clientes con confianza.",
      "pricing.tier.flow": "Atiende 1:1 y enseña 1:muchos — tu negocio del cuidado completo.",
      "pricing.tier.ascend": "Haz crecer tu clínica y tu academia juntas.",
      "pricing.tier.orbit": "Dirige una organización del cuidado multi-profesional a escala empresarial.",
      "hero.trustedBy": "Usado por más de 2 000 profesionales en todo el mundo",
      "ecosystem.eyebrow": "El ecosistema",
      "ecosystem.titleA": "Dos pilares. Nueve módulos.",
      "ecosystem.titleB": "Tú decides cómo combinarlos.",
      "ecosystem.title": "Un ecosistema completo",
      "ecosystem.subtitle": "Todas las herramientas para hacer crecer tu práctica.",
      "ecosystem.practice": "Gestión de la práctica",
      "ecosystem.journeys": "Viajes de pacientes",
      "ecosystem.ai": "Asistente IA",
      "ecosystem.telehealth": "Telesalud",
      "ecosystem.automations": "Automatizaciones",
      "ecosystem.payments": "Pagos y facturación",
      "ecosystem.insights": "Analítica e insights",
      "ecosystem.courses": "Cursos y educación",
      "ecosystem.community": "Comunidad y membresías",
      "pricing.title": "Precios transparentes",
      "pricing.subtitle": "Elige el plan ideal para tu práctica. Todos los planes incluyen una prueba gratuita — se requiere una tarjeta al registrarte, y no se cobra nada hasta que termine la prueba.",
      "pricing.monthly": "Mensual",
      "pricing.annual": "Anual",
      "pricing.annualWithSave": "Anual · ahorra hasta {percent}%",
      "pricing.billedAnnually": "Facturado {total} al año · {saved} ahorrados",
      "pricing.extraPractitioner": "+ {price}/mes por profesional adicional",
      "pricing.eyebrow": "Planes de suscripción",
      "pricing.headingA": "Elige tu plan,",
      "pricing.headingB": "un solo recorrido",
      "pricing.pickCycle": "Facturación mensual o anual, como prefieras.",
      "pricing.pickCycleSave": "Mensual, o ahorra hasta {percent}% con la facturación anual.",
      "pricing.choosePlan": "Elegir {plan}",
      "pricing.contactSales": "Hablar con ventas",
      "pricing.funnel.eyebrow": "El recorrido por defecto",
      "pricing.funnel.combo": "«{plan} + {install} + {porting}» =",
      "pricing.funnel.amount": "{monthly}/mes + {oneTime} pago único",
      "pricing.funnel.promise": "→ todo instalado, todo migrado, en línea en una semana.",
      "pricing.perMonth": "/mes",
      "pricing.perYear": "/año",
      "pricing.selectPlan": "Elegir este plan",
      "pricing.comingSoon": "Próximamente",
      "pricing.eta": "· {eta}",
      "pricing.unlimited": "Ilimitado",
      "footer.tagline": "Hecho para quienes sanan y enseñan.",
      "footer.rights": "Todos los derechos reservados.",
      "finalCta.title": "En línea en una semana.",
      "finalCta.subtitle": "Atiende y enseña desde una sola plataforma. Prueba gratuita de {days} días — se requiere una tarjeta, no se cobra nada hasta que termine.",
      "finalCta.cta": "Probar gratis",
      "footer.copyright": "© {year} Solunary · Hecho para quienes sanan y enseñan",
      "footer.product": "Producto",
      "footer.legal": "Legal",
      "footer.company": "Empresa",
      "footer.terms": "Términos del servicio",
      "footer.privacy": "Política de privacidad",
      "footer.features": "Funciones",
      "footer.pricing": "Precios",
      "footer.marketplace": "Marketplace",
      "footer.support": "Soporte y Contacto",
      "footer.contact": "Contacto",
      "terms.pageTitle": "Términos y Condiciones",
      "terms.pageSubtitle": "Todo lo que necesitas saber sobre tus derechos, responsabilidades y el uso de la plataforma Solunary.",
      "terms.tableOfContents": "Índice de contenidos",
      "terms.searchPlaceholder": "Buscar términos, cláusulas, temas (reembolso, IA, registros...)",
      "terms.noResults": "Ninguna cláusula coincide con tu búsqueda.",
      "terms.clearSearch": "Borrar búsqueda",
      "terms.print": "Imprimir / PDF",
      "terms.copied": "¡Enlace copiado!",
      "terms.copyLink": "Copiar enlace de sección",
      "terms.lastUpdated": "Última actualización",
      "terms.effectiveDate": "Fecha de efecto",
      "terms.version": "Versión",
      "terms.summaryTitle": "Aspectos destacados en un vistazo",
      "terms.summary1Title": "Comerciante de registro",
      "terms.summary1Desc": "Solunary procesa cobros y gestiona el libro contable de doble entrada vía Stripe.",
      "terms.summary2Title": "Registros de bienestar",
      "terms.summary2Desc": "Solunary no es un EMR certificado. El profesional conserva la responsabilidad clínica y regulatoria.",
      "terms.summary3Title": "Supervisión humana de IA",
      "terms.summary3Desc": "Todos los contenidos de IA son borradores que requieren validación previa del profesional.",
      "terms.summary4Title": "Tus datos y contenidos",
      "terms.summary4Desc": "Mantienes el 100 % de la propiedad intelectual sobre tus clientes, cursos y contenidos.",
      "terms.practiceTermsTitle": "Condiciones de reserva de la consulta",
      "terms.practiceTermsBadge": "Consulta",
      "terms.contactTitle": "¿Preguntas sobre nuestros términos?",
      "terms.contactDesc": "Nuestro equipo legal y de cumplimiento está a tu disposición para ayudarte.",
      "terms.contactButton": "Contactar al equipo legal",
      "terms.allClauses": "Todas las cláusulas",
      "terms.showingCount": "{count} secciones encontradas",
      "support.badge": "Soporte y Contacto",
      "support.pageTitle": "¿Cómo podemos ayudarte?",
      "support.pageSubtitle": "Ya sea que estés conociendo Solunary, gestionando tu consulta o tengas dudas legales, nuestro equipo está aquí para asistirte.",
      "support.directEmailTitle": "Correo directo",
      "support.directEmailSub": "Contacta con todo el equipo",
      "support.emailHelpNote": "Todas las consultas enviadas a esta dirección son atendidas con seguimiento personalizado.",
      "support.helpfulResources": "Recursos útiles",
      "support.formHeading": "Abrir un ticket de soporte",
      "support.formHelp": "Nuestro equipo responde normalmente en un plazo de 24 a 48 horas laborables. Recibirás una confirmación por correo.",
      "support.formTitle": "¿Cómo podemos ayudarte?",
      "support.formSubtitle": "Envía tu consulta a continuación o escríbenos directamente a",
      "support.nameLabel": "Tu nombre",
      "support.emailLabel": "Tu correo electrónico",
      "support.categoryLabel": "Categoría de la consulta",
      "support.subjectLabel": "Asunto",
      "support.messageLabel": "Mensaje",
      "support.subjectPlaceholder": "Breve resumen de tu consulta",
      "support.messagePlaceholder": "Proporciona cualquier detalle necesario para asistirte eficazmente...",
      "support.send": "Enviar mensaje",
      "support.submitting": "Enviando…",
      "support.successTitle": "¡Consulta recibida!",
      "support.successMessage": "Gracias por contactar a Solunary. Hemos registrado tu consulta y enviado un acuse de recibo a tu correo electrónico.",
      "support.ticketReference": "Referencia del ticket",
      "support.anotherInquiry": "Enviar otra consulta",
      "support.catGeneral": "Consulta general",
      "support.catBilling": "Facturación y Suscripciones",
      "support.catTechnical": "Soporte técnico y Plataforma",
      "support.catLegal": "Legal, Privacidad y Cumplimiento",
      "support.catFeedback": "Comentarios y Sugerencias",
      "support.catPartnership": "Alianzas y Prensa",
      "support.errorName": "Por favor, introduce tu nombre.",
      "support.errorEmail": "Por favor, introduce un correo electrónico válido.",
      "support.errorSubject": "Por favor, introduce el asunto de tu consulta.",
      "support.errorMessage": "Por favor, describe tu consulta en al menos 5 caracteres.",
      "support.errorGeneric": "Error al enviar el ticket. Por favor, escribe directamente a hey@solunary.health.",
      "support.close": "Cerrar",
      "support.done": "Listo",
      "signup.title": "Crea tu cuenta Solunary",
      "signup.subtitle": "Prueba gratuita de {days} días — se requiere una tarjeta al registrarte, pero no se cobra nada hasta que termine la prueba.",
      "signup.practiceName": "Nombre de la práctica",
      "signup.slug": "Tu dirección web",
      "signup.slugHint": "Elige tu subdominio. Podrás conectar tu propio dominio personalizado más adelante.",
      "signup.slugChecking": "Verificando…",
      "signup.slugAvailable": "Dirección disponible",
      "signup.currency": "Moneda",
      "signup.plan": "Plan",
      "signup.submit": "Comenzar mi prueba",
      "signup.submitting": "Creando…",
      "signup.demoModeActive": "Modo demo activo",
      "signup.demoModeBody": "No se realizará ningún cobro real. La cuenta se activará de inmediato con fines de prueba.",
      "signup.googleConnected": "Conectado con Google:",
      "signup.emailHintGoogle": "La dirección de tu cuenta de Google — se usará para iniciar sesión.",
      "signup.emailHintManual": "Usa la dirección de la cuenta de Google con la que iniciarás sesión después.",
      "signup.or": "o",
      "signup.ownerNamePlaceholder": "Dra. Marie Dupont",
      "signup.practiceNamePlaceholder": "Clínica de naturopatía Lune",
      "signup.practiceNameOptionalHint": "Opcional: usaremos tu dirección de correo. Podrás cambiarlo después en Ajustes.",
      "signup.billingLabel": "Facturación",
      "signup.billingMonthly": "Mensual",
      "signup.billingAnnual": "Anual · 2 meses gratis",
      "signup.acceptTermsPrefix": "Acepto los",
      "signup.acceptTermsMiddle": "y la",
      "faq.title": "Preguntas frecuentes",
      "faq.q1": "¿Cuánto tarda en estar en línea mi consulta?",
      "faq.a1": "Con el paquete Turnkey Install, estás operativo en una semana. Sin Turnkey, calcula 24h para empezar + unos días para personalizar.",
      "faq.q2": "¿Puedo migrar mis datos existentes?",
      "faq.a2": "Sí. {express} ({expressPrice}) automatiza la migración desde Practice Better, Jane, SimplePractice, Healthie y Acuity. {assisted} ({assistedPrice}) gestiona los casos complejos.",
      "faq.a2Generic": "Sí. La migración automatizada cubre Practice Better, Jane, SimplePractice, Healthie y Acuity, y una opción asistida gestiona los casos complejos — consulta los paquetes de migración de datos más arriba.",
      "faq.q3": "¿Y si tengo un equipo de varios profesionales?",
      "faq.a3": "El plan {plan} incluye {included} profesionales y después {extra}/mes por profesional adicional. Las organizaciones enterprise cuentan con un plan a medida (profesionales ilimitados, SSO, etc.).",
      "faq.a3Generic": "Sí. Los planes para varios profesionales incluyen un equipo de profesionales y después cobran un importe mensual por cada profesional adicional; la tabla de precios de arriba muestra las cifras vigentes. Las organizaciones enterprise cuentan con un plan a medida (profesionales ilimitados, SSO, etc.).",
      "faq.q4": "¿Cómo funciona Solunary Pay?",
      "faq.a4": "Los pagos de tus clientes se procesan mediante Stripe y los factura Solunary a {rate}. Más simple que una integración Stripe directa, y activado con un clic.",
      "faq.a4Generic": "Los pagos de tus clientes se procesan mediante Stripe y los factura Solunary. Más simple que una integración Stripe directa, y activado con un clic; la tarifa vigente aparece en las tarifas de plataforma más arriba.",
      "faq.q5": "¿Y si quiero cancelar?",
      "faq.a5": "Sin compromiso en el plan mensual. Cancela con un clic desde tu panel. La facturación anual te permite ahorrar hasta un {percent}%.",
      "faq.a5Generic": "Sin compromiso en el plan mensual. Cancela con un clic desde tu panel. La facturación anual cuesta menos que pagar mes a mes.",
      "feature.practice.text": "Reservas, calendario, facturas, tarjetas regalo, productos — tu núcleo operativo.",
      "feature.journeys.text": "Protocolos de varios pasos, formularios de admisión, planes de tratamiento, seguimientos.",
      "feature.ai.text": "Impulsado por Claude Sonnet 4.5. Chatbot de pacientes + asistente admin + insights diarios.",
      "feature.telehealth.text": "Videollamadas HD, notas de sesión, firmas electrónicas, grabaciones — totalmente integrado.",
      "feature.automations.text": "Motor Disparador → Acción. 7 disparadores, 5 acciones, editor visual sin código.",
      "feature.payments.text": "Solunary Pay. Suscripciones, pagos únicos, tarjetas regalo. Multidivisa.",
      "feature.insights.text": "Briefings de IA diarios + paneles de KPI + informes de retención por cohorte.",
      "feature.courses.text": "Vende cursos, programas, membresías. Contenido programado, certificados.",
      "feature.community.text": "Círculos privados, comunidades de pago, foros ligados a tus planes de tratamiento."
  },
};
